import { mapToNamedProperty, NamedProperty } from "sprint-common-web";

import { DeliveryResponse } from "../../api/delivery-api/DeliveryResponse";
import { DeliveryType } from "../../types/DeliveryType";

export type DeliveryItem = UploadDeliveryItem | AsperaDeliveryItem | BucketDeliveryItem | ArchiveDeliveryItem;

export interface UploadDeliveryItem {
    type: DeliveryType.Upload;
    file: {
        arrivalDate: string;
        path: string;
        size?: number;
    };
    sender: {
        name?: string;
        email?: string;
        subject?: string;
        message?: string;
    };
    originator: NamedProperty;
}

export interface AsperaDeliveryItem {
    type: DeliveryType.Aspera;
    file: {
        arrivalDate: string;
        path: string;
        size?: number;
    };
    sender: {
        name?: string;
        email?: string;
        subject?: string;
        message?: string;
    };
    asperaInfo: {
        fileId: string;
        inboxId: string;
        inboxName: string;
        packageFileId: string;
        packageId: string;
        packageIsDeleted: boolean;
    };
}

export interface BucketDeliveryItem {
    type: DeliveryType.DeliveryBucket;
    file: {
        arrivalDate: string;
        path: string;
        size?: number;
    };
    originator: NamedProperty;
    bucketInfo: {
        uniqueId: string;
        bucketName: string;
    };
}

export interface ArchiveDeliveryItem {
    type: DeliveryType.Archive;
    file: {
        arrivalDate: string;
        path: string;
        size?: number;
    };
    sender: {
        name?: string;
        email?: string;
        subject?: string;
        message?: string;
    };
    originator: NamedProperty;
    bucketName: string;
}

export const mapToDeliveryItem = (deliveryResponse: DeliveryResponse): DeliveryItem => {
    switch (deliveryResponse.type) {
        case DeliveryType.Aspera: {
            return {
                type: DeliveryType.Aspera,
                file: {
                    arrivalDate: deliveryResponse.file.arrivalDate,
                    path: deliveryResponse.file.path,
                    size: deliveryResponse.file.size
                },
                sender: {
                    email: deliveryResponse.sender.email,
                    name: deliveryResponse.sender.name,
                    subject: deliveryResponse.sender.subject,
                    message: deliveryResponse.sender.message
                },
                asperaInfo: {
                    fileId: deliveryResponse.asperaInfo.fileId,
                    inboxId: deliveryResponse.asperaInfo.inboxId,
                    inboxName: deliveryResponse.asperaInfo.inboxName,
                    packageFileId: deliveryResponse.asperaInfo.packageFileId,
                    packageId: deliveryResponse.asperaInfo.packageId,
                    packageIsDeleted: deliveryResponse.asperaInfo.packageIsDeleted
                }
            };
        }

        case DeliveryType.Upload: {
            return {
                type: DeliveryType.Upload,
                file: {
                    arrivalDate: deliveryResponse.file.arrivalDate,
                    path: deliveryResponse.file.path,
                    size: deliveryResponse.file.size
                },
                sender: {
                    email: deliveryResponse.sender.email,
                    name: deliveryResponse.sender.name,
                    subject: deliveryResponse.sender.subject,
                    message: deliveryResponse.sender.message
                },
                originator: mapToNamedProperty(deliveryResponse.originator)
            };
        }

        case DeliveryType.DeliveryBucket: {
            return {
                type: DeliveryType.DeliveryBucket,
                file: {
                    arrivalDate: deliveryResponse.file.arrivalDate,
                    path: deliveryResponse.file.path,
                    size: deliveryResponse.file.size
                },
                originator: mapToNamedProperty(deliveryResponse.originator),
                bucketInfo: {
                    uniqueId: deliveryResponse.bucketInfo.uniqueId,
                    bucketName: deliveryResponse.bucketInfo.bucketName
                }
            };
        }

        case DeliveryType.Archive: {
            return {
                type: DeliveryType.Archive,
                file: {
                    arrivalDate: deliveryResponse.file.arrivalDate,
                    path: deliveryResponse.file.path,
                    size: deliveryResponse.file.size
                },
                sender: {
                    email: deliveryResponse.sender.email,
                    name: deliveryResponse.sender.name,
                    subject: deliveryResponse.sender.subject,
                    message: deliveryResponse.sender.message
                },
                originator: mapToNamedProperty(deliveryResponse.originator),
                bucketName: deliveryResponse.bucketName
            };
        }
    }
};
